// site down
import bot from "../images/bot.gif";

// ads 3x4
import Ad3x4x1 from "../images/ads_3x4_1.svg";
import Ad3x4x2 from "../images/ads_3x4_2.svg";
import Ad3x4x3 from "../images/ads_3x4_3.svg";
import Ad3x4x4 from "../images/ads_3x4_4.svg";
import Ad3x4x5 from "../images/ads_3x4_5.svg";
import Ad3x4x6 from "../images/ads_3x4_6.svg";
import Ad3x4x7 from "../images/ads_3x4_7.svg";
import Ad3x4x8 from "../images/ads_3x4_8.svg";
import Ad3x4x9 from "../images/ads_3x4_9.svg";
import Ad3x4x10 from "../images/ads_3x4_10.svg";
import Ad3x4x11 from "../images/ads_3x4_11.svg";
import Ad3x4x12 from "../images/ads_3x4_12.svg";
import Ad3x4x13 from "../images/ads_3x4_13.svg";
import Ad3x4x14 from "../images/ads_3x4_14.svg";
import Ad3x4x15 from "../images/ads_3x4_15.svg";
import Ad3x4x16 from "../images/ads_3x4_16.svg";

// ads 4x3
import Ad4x3x1 from "../images/ads_4x3_1.svg";
import Ad4x3x2 from "../images/ads_4x3_2.svg";
import Ad4x3x3 from "../images/ads_4x3_3.svg";
import Ad4x3x4 from "../images/ads_4x3_4.svg";
import Ad4x3x5 from "../images/ads_4x3_5.svg";
import Ad4x3x6 from "../images/ads_4x3_6.svg";
import Ad4x3x7 from "../images/ads_4x3_7.svg";
import Ad4x3x8 from "../images/ads_4x3_8.svg";
import Ad4x3x9 from "../images/ads_4x3_9.svg";
import Ad4x3x10 from "../images/ads_4x3_10.svg";
import Ad4x3x11 from "../images/ads_4x3_11.svg";
import Ad4x3x12 from "../images/ads_4x3_12.svg";
import Ad4x3x13 from "../images/ads_4x3_13.svg";
import Ad4x3x14 from "../images/ads_4x3_14.svg";
import Ad4x3x15 from "../images/ads_4x3_15.svg";
import Ad4x3x16 from "../images/ads_4x3_16.svg";
import Ad4x3x17 from "../images/ads_4x3_17.svg";

// explosions
import ExplosionImg1 from "../images/explosion.png";
import ExplosionImg2 from "../images/explosion2.png";
import ExplosionImg3 from "../images/explosion3.png";

// fs images
// logos
import DigitalOcean from "../images/client-logos/digital-ocean.png";
import DonorsChoose from "../images/client-logos/donors-choose.png";
import Jane from "../images/client-logos/jane.png";
import Maritzcx from "../images/client-logos/maritzcx.png";
import Segment from "../images/client-logos/segment.png";
import Teespring from "../images/client-logos/teespring.png";
// portraits
import Chris from "../images/user-portraits/chris.png";
import Dan from "../images/user-portraits/dan.png";


// Exports - Keep this at end of the code, else compile will fail
export { bot };
export { ExplosionImg1, ExplosionImg2, ExplosionImg3 };
export { Ad3x4x1, Ad3x4x2, Ad3x4x3, Ad3x4x4, Ad3x4x5, Ad3x4x6, Ad3x4x7, Ad3x4x8, Ad3x4x9, Ad3x4x10, Ad3x4x11, Ad3x4x12, Ad3x4x13, Ad3x4x14, Ad3x4x15, Ad3x4x16};
export { Ad4x3x1, Ad4x3x2, Ad4x3x3, Ad4x3x4, Ad4x3x5, Ad4x3x6, Ad4x3x7, Ad4x3x8, Ad4x3x9, Ad4x3x10, Ad4x3x11, Ad4x3x12, Ad4x3x13, Ad4x3x14, Ad4x3x15, Ad4x3x16, Ad4x3x17};
export { DigitalOcean, DonorsChoose, Jane, Maritzcx, Segment, Teespring };
export { Chris, Dan };


// WEBPACK FOOTER //
// ./src/components/Images.js